module.exports = "/dashboard/manage/users/selfInvite/self-invite-notification-modal-4ca442.html";